import axios from 'axios';

export default function (context, {data, cb}) {
    context.state.loading = true;
    axios({
        method: 'post',
        url: '/tourclient/payment/invoices',
        data: 'request=' + JSON.stringify(data),
        requestId: 'tourclient/payment/invoices'
    }).then(({data}) => {
        context.commit('set', data);
        if (cb) cb(data);
    }).catch(e => {
        context.state.loading = false;
        context.dispatch('error', e, {root: true});
    });
}